import { STALE_TIME } from "#app/http/ReactQueryProvider";
import { fetchSimilarPartFeedbacks } from "#modules/feedback/infra/fetchSimilarPartFeedbacks.api";
import { queryKeys } from "#shared/queryKeys/queryKeys";

export const similarPartFeedbacksQuery = (sourcePartId: string | undefined) => ({
  queryKey: queryKeys.similarPartFeedbacks.bySourcePart(sourcePartId),
  queryFn: () => fetchSimilarPartFeedbacks(sourcePartId),
  staleTime: STALE_TIME,
  enabled: !!sourcePartId,
});
